import { render, staticRenderFns } from "./import-license.vue?vue&type=template&id=09773ba1&scoped=true"
import script from "./import-license.vue?vue&type=script&lang=js"
export * from "./import-license.vue?vue&type=script&lang=js"
import style0 from "./import-license.vue?vue&type=style&index=0&id=09773ba1&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09773ba1",
  null
  
)

export default component.exports